import { createSlice } from "@reduxjs/toolkit";
import { generateNavList } from "../../utils/navigationConfig";

// Generate the NAV_LIST dynamically
export const NAV_LIST = generateNavList();

const navigationSlice = createSlice({
  name: "navigationSlice",
  initialState: {
    selectedNav: NAV_LIST[0]?.nav ?? "",
  },
  reducers: {
    selectNav(state, action) {
      state.selectedNav = action.payload;
    },
  },
});

export const navigationActions = navigationSlice.actions;

export default navigationSlice.reducer;
